module.exports = __webpack_public_path__ + "img/icon_vip_bili@2x.b052c91d.png";